import * as Styled from 'components/Toolkit/HtmlInfoPanel/HtmlInfoPanel.styled';
import type { HtmlInfoPanelProps } from 'components/Toolkit/HtmlInfoPanel/HtmlInfoPanel.typed';

const HtmlInfoPanel = (props: HtmlInfoPanelProps) => {
  const { heading, htmlArray, className } = props;

  const buildList = (input: string[]) => {
    return input.map((entry: string, index: number) => (
      <Styled.ListItem
        key={`html-info-panel-list-item-${index}`}
        dangerouslySetInnerHTML={{ __html: entry }}
      />
    ));
  };

  return (
    <Styled.HtmlInfoPanelContainer className={className}>
      <Styled.Heading>{heading}</Styled.Heading>
      {htmlArray && (
        <Styled.ListContainer>{buildList(htmlArray)}</Styled.ListContainer>
      )}
    </Styled.HtmlInfoPanelContainer>
  );
};

export { HtmlInfoPanel };
